import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import contactStyle from './Contact.module.scss';
import { RoutesUrl } from '../../../router/RouterUrls';
import ClientConfig from '../../../config';
import IButton from '../../elements/iButton/IButton';
import Reveal from '../../elements/reveal/Reveal';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Contact = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <section className={contactStyle.section}>
            <div className={contactStyle.inner}>
                <Reveal>
                    <div className={contactStyle.panel}>
                        <div className={contactStyle.glow} aria-hidden='true' />

                        <span className={contactStyle.eyebrow}>{t('contact.eyebrow')}</span>
                        <h2 className={contactStyle.title}>{t('contact.contact')}</h2>
                        <p className={contactStyle.description}>{t('contact.description')}</p>

                        <div className={contactStyle.actions}>
                            <IButton
                                title={t('contact.getInTouch')}
                                onClick={() => navigate(RoutesUrl.contacts)}
                                variant='primary'
                                size='lg'
                                icon={<ArrowForwardIcon />}
                            />
                            <a className={contactStyle.emailLink} href={`mailto:${ClientConfig.email}`}>
                                {ClientConfig.email}
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Contact;
